var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-param */
import { Component, Prop, CustomElement, html } from '@sick-davinci/ce-decorators';
import { style } from './ElementContainer.style'; // import theme, so color-variables can be resolved

import '@sick-davinci/theme-base/theme/light_theme.js';
import '@sick-davinci/theme-base/theme/light_ddg_theme.js';
/**
 * A container for dashboard elements (with possibilities to change settings, navigate, ...)
 *
 * @example
 * ```
 *   <davinci-element-container heading="Container" style="width: 300px; height: 300px; text-align: center">
 *     <div style="color: #007CC1; font-size: 3rem;">I am a slot element</div>
 *   </davinci-element-container>
 * ```
 * @slot { * } default - default slot, can consume any element. Slot is shown in the main area.
 * @slot { svg } left-icon - left header icon slot, can consume a svg-icon; use fill="currentColor" to make it themable
 * @slot { svg } mid-icon - middle header icon slot, can consume a svg-icon; use fill="currentColor" to make it themable
 * @slot { svg } right-icon - right header icon slot, can consume a svg-icon; use fill="currentColor" to make it themable
 */

export let ElementContainer = (_dec = Component({
  tag: 'davinci-element-container',
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = class ElementContainer extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "state", _descriptor, this);

    _initializerDefineProperty(this, "heading", _descriptor2, this);

    _initializerDefineProperty(this, "noHeader", _descriptor3, this);
  }

  /**
   * See base class
   */
  render() {
    return html`
    <header>
      <div id='title'>${this.heading}</div>
      <slot name="left-icon"></slot>
      <slot name="mid-icon"></slot>
      <slot name="right-icon"></slot>
    </header>
    <main>
      <slot></slot>
    </main>`;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "state", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "heading", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'Caption';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "noHeader", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
